module.exports = __webpack_public_path__ + "a8f579beb3d99c0e0b5be0aca99c54a7.svg";